import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import Constants from './Constants';


class CountryStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.UPDATE_COUNTRY:
        return action.country;

      default:
        return state;
    }
  }
}

export default new CountryStore();



// WEBPACK FOOTER //
// ./src/flux/CountryStore.js